// Export types
export type { Language, Translations } from './types';

// Import all language translations
import { en } from './locales/en';
import { vi } from './locales/vi';
import { es } from './locales/es';
import { pt } from './locales/pt';
import { zh } from './locales/zh';
import { id } from './locales/id';
import type { Language, Translations } from './types';

// Translations map - clean code, no if-else
export const translations: Record<Language, Translations> = {
  en,
  vi,
  es,
  pt,
  zh,
  id,
};

// Language names for display in UI
export const languageNames: Record<Language, string> = {
  en: 'English',
  vi: 'Tiếng Việt',
  es: 'Español',
  pt: 'Português',
  zh: '中文',
  id: 'Bahasa Indonesia',
};

// Get available languages
export const availableLanguages: Language[] = ['en', 'vi', 'es', 'pt', 'zh', 'id'];
